
import { defineComponent, reactive, ref } from "vue";
import { User, Key } from "@element-plus/icons-vue";
import type { FormInstance, FormRules } from "element-plus";
import { Actions } from "@/store/enums/StoreEnums";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { errManager } from "@/core/config/Tools";
import { asideTheme, themeLightLogo, themeDarkLogo, } from "@/core/helpers/config";
//services
import authService from "@/core/services/AuthService";

export default defineComponent({
    name: "sign-in",
    setup() {
        const store = useStore();
        const router = useRouter();
        const ruleFormRef = ref < FormInstance > ();
        const submitButton = ref < HTMLButtonElement | null > (null);
        const emailSupport = ref(process.env.VUE_APP_EMAIL)

        const form = reactive({
            username: "",
            password: "",
        });

        const rules = reactive < FormRules > ({
            username: [{
                required: true,
                message: "Ingrese nombre de usuario",
                trigger: ["blur", "change"],
            }, ],
            password: [{
                required: true,
                message: "Ingrese contraseña",
                trigger: ["blur", "change"],
            }, ],
        });


        //Form submit function
        const onSubmitLogin = async (formEl: FormInstance | undefined) => {
            if (!formEl) return;

            await formEl.validate((valid, fields) => {
                if (valid) onLogin();
            });
        };

        const onLogin = async () => {
            store.dispatch(Actions.LOGOUT);

            if (submitButton.value) {
                submitButton.value!.disabled = true;
                submitButton.value.setAttribute("data-kt-indicator", "on");
            }

            await authService.logIn(form)
            .then( ({data}) => {
                submitButton.value?.removeAttribute("data-kt-indicator");
                submitButton.value!.disabled = false;
                if(data.status){
                    store.dispatch(Actions.LOGIN, data)
                    router.push({
                        name: data.redirect
                    });
                }
            }).catch( ({response}) => {
                submitButton.value?.removeAttribute("data-kt-indicator");
                submitButton.value!.disabled = false;
                errManager(response)
            })
        };

        return {
            asideTheme,
            themeLightLogo, 
            themeDarkLogo,
            emailSupport,
            User,
            Key,
            form,
            rules,
            ruleFormRef,
            onSubmitLogin,
            submitButton,
        };
    },
});
